import React, { FC } from 'react';
import { Card, Text, useClipboard } from '@mofid-securities/uikit';
import {
  IMelliCardAccountInfoItem,
  IMelliCardInquiry,
} from '@/services/apis/fundTransfer/types';
import { Icon } from '@/components/atomic/Icon';
import Toast from '@/components/Toast';
import { classnames } from '@/utils/classnames';
import { replaceIRFromIban } from '@/utils/string';
import { HamiBalanceSlideBackgroundOverlay } from './HamiBalanceSlideBackgroundOverlay';

interface IHamiBalanceSlideCardBackProps {
  melliCardInquiry: IMelliCardInquiry | undefined;
  className?: string;
}

export const HamiBalanceSlideCardBack: FC<IHamiBalanceSlideCardBackProps> = ({
  melliCardInquiry,
  className,
}) => {
  const [, copyText] = useClipboard();

  const items: IMelliCardAccountInfoItem[] = [
    {
      title: 'شماره حساب',
      value: melliCardInquiry?.accountNo || '',
      isSheba: false,
    },
    {
      title: 'شماره شبا',
      value: melliCardInquiry?.iban || '',
      isSheba: true,
    },
  ];

  const copySelectedText = (text: string, isSheba: boolean) => {
    const shebaText = 'شماره شبا شما با موفقیت کپی شد.';
    const accountText = 'شماره حساب شما با موفقیت کپی شد.';
    copyText(text);
    Toast.open({
      variant: 'info',
      children: isSheba ? shebaText : accountText,
      hasIcon: false,
      isDismissible: true,
    });
  };
  return (
    <Card
      className={classnames(
        'absolute right-0 top-0 flex h-[160px] flex-col justify-around overflow-hidden rounded-2xl text-sm font-regular text-white md:!px-10',
        className
      )}
      style={{
        backfaceVisibility: 'hidden',
        transform: 'rotateX(180deg)',
      }}
    >
      <HamiBalanceSlideBackgroundOverlay />
      {items.map((item) => (
        <div key={item.value} className="flex items-center justify-between">
          <Text className="w-20">{item.title}</Text>
          <div
            className="relative z-[1] flex h-[34px] w-[calc(100%-70px)] cursor-pointer items-center justify-between px-1 text-xs md:w-[calc(100%-120px)] md:px-4 md:text-sm"
            onClick={() => copySelectedText(item?.value, item.isSheba)}
          >
            <div className="absolute right-0 top-0 z-0 h-full w-full rounded-md bg-[#0e0c734a] opacity-30 "></div>
            <Icon icon="content_copy" size={20} />
            <Text className="flex flex-row-reverse items-center gap-x-2">
              {item?.isSheba && (
                <Text
                  className="text-mofidgreen-filled-primary-enabled "
                  weight="medium"
                >
                  IR
                </Text>
              )}
              {replaceIRFromIban(item?.value)}
            </Text>
          </div>
        </div>
      ))}
    </Card>
  );
};
